
import type { PropType } from 'vue'
import type { InsightsBarData, SecondaryInsightsBarData } from './epb-insights-bar.types'

import { defineComponent, getCurrentInstance, onMounted, ref } from 'vue'
import { UiTooltip } from '../../keen-ui'

import { EpbInputHelp } from '../../shared/epb-input-help'
import { EpbText } from '../../shared/epb-text'

export default defineComponent({
  name: 'EpbInsightsBar',
  components: {
    EpbInputHelp,
    EpbText,
    UiTooltip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    insightsData: {
      type: Object as PropType<InsightsBarData>,
      required: true,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const baseClass = 'epb-insights-bar'

    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const itemRefs = ref<Element[]>([])

    onMounted(() => {
      itemRefs.value = ctx.proxy.$refs.itemRefs as Element[]
    })

    const formatNumber = (number: number): string => {
      return ctx.proxy.$epb.utils.formatNumber(number, { maximumFractionDigits: 2 }, true)
    }

    const getPercentageChange = (item: SecondaryInsightsBarData): number => {
      if (!item.previousQuantity && item.previousQuantity !== 0) {
        return props.insightsData.main.quantity
          ? Math.round(
              ((props.insightsData.main.quantity - item.quantity) /
                props.insightsData.main.quantity) *
                100,
            )
          : 0
      } else {
        return item.quantity
          ? item.previousQuantity !== 0
            ? Math.round((item.quantity / item.previousQuantity) * 100)
            : 100
          : 0
      }
    }

    return {
      baseClass,
      formatNumber,
      itemRefs,
      getPercentageChange,
    }
  },
})
